import React, { useRef, useLayoutEffect } from 'react';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { guestListData } from '@data-ts/pages/guest-list';
import { Box } from '@components/Box';
import ScrollMagic from 'scrollmagic';
import { useScrollController } from '@context/ScrollControllerProvider/useScrollController';
import { useIsMounted } from '@hooks/useIsMounted';
import { gsap } from 'gsap';
import { MoreTimeTogetherWrapper, GradientWrap, TextWrapper, StyledBackgroundPhoto } from './MoreTimeTogether.styles';
import { useThemeMediaQuery } from '@hooks/useThemeMediaQuery';

export const MoreTimeTogether = () => {
  const textRef = useRef<HTMLDivElement>(null);
  const scrollController = useScrollController();
  const isMounted = useIsMounted();
  const isMobile = useThemeMediaQuery('below_sm');

  useLayoutEffect(() => {
    let scene: InstanceType<typeof ScrollMagic.Scene> | undefined;
    let moreTimeTogether: ReturnType<typeof gsap.timeline>;

    if (scrollController && isMounted) {
      const initTimeline = () => {
        if (scrollController) {
          moreTimeTogether = gsap.timeline({ paused: true, defaults: { ease: 'none' } });
          moreTimeTogether.to(
            textRef.current,
            {
              y: isMobile ? '50vh' : '65vh',
              duration: 100,
            },
            '+=1'
          );
        }
      };
      const initScene = () => {
        scene = new ScrollMagic.Scene({
          triggerElement: '#MoreTimeTogether',
          triggerHook: 'onCenter',
          duration: '200%',
        })
          .addTo(scrollController)
          .on('progress', (event: ScrollMagic.SceneProgressEvent) => {
            moreTimeTogether?.progress(event.progress);
          });
      };
      initTimeline();
      initScene();
    }
    const clearScene = () => {
      if (moreTimeTogether) {
        moreTimeTogether.progress(0);
        moreTimeTogether.kill();
      }
      if (scene) {
        scene.destroy(true);
      }
    };
    return clearScene;
  }, [scrollController, isMounted, isMobile]);
  return (
    <MoreTimeTogetherWrapper id="MoreTimeTogether">
      <GradientWrap />
      <StyledBackgroundPhoto
        src={cloudAssetUrl(isMobile ? 'sitewide/block_emotional-break/bucketlist_m.jpg' : 'sitewide/block_emotional-break/bucketlist.jpg', {
          optimization: 'mild',
        })}
        paddingTop={[9, 14]}
        height={'150vh'}
        heightMobile={'84vh'}
        moveText={true}
        backgroundHeight={'84%'}
        backgroundPosition={'bottom'}
      >
        <Box ref={textRef}>
          <TextWrapper color="yellow1" variant="hed96Break" tagName="h2">
            {guestListData.moreTimeTogetherText}
          </TextWrapper>
        </Box>
      </StyledBackgroundPhoto>
    </MoreTimeTogetherWrapper>
  );
};
